module.exports = __webpack_public_path__ + "img/photo_404.962d2dbe.jpg";